<div class="card">
  <div class="card-header">
    <div class="media">
      <!-- Discussion Author image start -->
      <a
        class="media-left media-middle"
        [routerLink]="['/profile', discussion.author.username]"
      >
        <img
          *ngIf="discussion.author.image"
          class="discussion-preview-user-img"
          [src]="discussion.author.image"
          alt="author-image"
        />
        <img
          *ngIf="!discussion.author.image"
          class="discussion-preview-user-img"
          [src]="defaultUserImg"
          alt="author-image"
        />
      </a>
      <!-- Discussion author image end -->

      <div class="media-body media-middle">
        <div class="company-name">
          <!-- Discussion author name start -->
          <a [routerLink]="['/profile', discussion.author.username]">
            <p>{{ discussion.author.username | slice: 0:30 }}</p>
          </a>
          <!-- Discussion author name end -->

          <span class="text-muted f-14">{{
            discussion.createdAt | date: "longDate":"UTC"
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="card-block">
    <!-- Discussion title start -->
    <a
      [routerLink]="['/discussion', discussion.slug]"
      class="card-title header-details"
    >
      <h6
        [innerHTML]="discussion.title | slice: 0:100"
        class="job-card-desc"
      ></h6>
    </a>
    <!-- Discussion title end -->

    <!-- Discussion Description start -->
    <a [routerLink]="['/discussion', discussion.slug]">
      <p
        [innerHTML]="discussion.description | slice: 0:150"
        class="text-muted"
      ></p>
    </a>
    <!-- Discussion description end -->

    <!-- Discussion image start -->
    <div class="media-body media-middle" *ngIf="discussion.image">
      <a class="media-middle" [routerLink]="['/discussion', discussion.slug]">
        <img
          *ngIf="discussion.image"
          class="discussion-image"
          [src]="discussion.image"
          alt="discussion-image"
        />
      </a>
    </div>
    <!-- Discussion image end -->

    <div class="job-lable">
      <span *ngFor="let tag of discussion.tagList" (click)="setTagFeed(tag)">
        <label class="label badge-success">
          {{ tag | slice: 0:20 }}
        </label>
      </span>
    </div>

    <!-- Community start -->
    <div>
      <div class="media-body media-middle">
        <div class="company-name">
          <!-- Community name start -->
          <a [routerLink]="['/community', discussion.community.name]">
            Posted in:
            <p class="text-muted">
              The {{ discussion.community.name }}
              <span class="text-primary">uMuzi</span>
            </p>
          </a>
          <!-- Community name end -->
        </div>
      </div>
    </div>
    <!-- Community end -->

    <hr />

    <!-- Panel start -->
    <div *ngIf="discussion.panel.length > 0">
      <div class="media-body media-middle">
        <div class="company-name">
          <i class="icofont icofont-listening" style="margin: 5px"></i>
          <span class="text-primary">{{ discussion.panel.length }} </span>
          <span *ngIf="discussion.panel.length === 1">panelist </span>
          <span *ngIf="discussion.panel.length > 1">panelists </span>
          <span>contributing</span>
        </div>
      </div>
    </div>
    <!-- Panel end -->

    <hr *ngIf="discussion.panel.length > 0" />

    <div class="text-center key-buttons">
      <!-- Upvote button start -->
      <upvote-discussion-button
        *ngIf="discussion.voted"
        [discussion]="discussion"
        (onToggle)="onToggleUpvote($event)"
        class="pull-left"
      >
      </upvote-discussion-button>
      <!-- Upvote button end-->

      <!-- Downvote button start -->
      <downvote-discussion-button
        *ngIf="discussion.voted"
        [discussion]="discussion"
        (onToggle)="onToggleDownvote($event)"
        class="pull-left"
      >
      </downvote-discussion-button>
      <!-- Downvote button end -->

      <!-- Bookmark button start -->
      <bookmark-discussion-button
        [discussion]="discussion"
        (onToggle)="onToggleBookmark($event)"
        class="pull-left"
      >
      </bookmark-discussion-button>
      <!-- Bookmark button start-->

      <!-- Read more button-->
      <button
        type="button"
        class="btn btn-info waves-effect waves-light btn-sm footer-button"
      >
        <div style="display: inline-block">
          <i class="icofont icofont-speech-comments"></i>
          <span>{{ discussion.commentCount }} </span>
        </div>
      </button>
    </div>
  </div>
</div>
